import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nav"
//
// Markiert den zur aktuellen Seite passenden Navigationslink als aktiv.
// Läuft clientseitig, weil die Navigation serverseitig gecacht wird und
// daher für jede Seite identisches HTML ausliefert - "aktiv" lässt sich
// also nicht mehr im gecachten Fragment selbst abbilden.
export default class extends Controller {
  connect () {
    this.highlight()
  }

  highlight () {
    const path = window.location.pathname

    this.element.querySelectorAll("a[href]").forEach(link => {
      if (link.origin !== window.location.origin) return

      const linkPath = link.pathname
      const active   = linkPath === path || path.startsWith(`${linkPath}/`)

      link.closest("li")?.classList.toggle("active", active)
      if (active) {
        link.setAttribute("aria-current", "page")
      } else {
        link.removeAttribute("aria-current")
      }
    })
  }
}
